import { useMemo } from 'react';
import useQuery from '../../../../../../hooks/useQuery';
import { DeliveryModes } from '../../../types';
import useStructureTypeIsFixed from './useStructureTypeIsFixed';

export default function useOnlineDeliveryModeFixedStructure() {
  const { isFixedType } = useStructureTypeIsFixed();
  const query = useQuery();
  const deliveryMode = query.get('deliveryMode');

  const isOnlineDeliveryModeAndFixedStructure = useMemo(() => {
    return deliveryMode === DeliveryModes.OL && isFixedType;
  }, [deliveryMode, isFixedType]);

  return {
    isOnlineDeliveryModeAndFixedStructure,
  };
}
